<template>
    <v-container>
      <h1>Проблемные адреса</h1>
  
      <v-data-table :headers="headers" :items="addresses">
        <!-- ✅ Современный синтаксис v-slot -->
        <template slot="item.actions" slot-scope="{ item }">
          <v-btn color="blue" @click="openEdit(item)">Исправить</v-btn>
          <v-btn color="red" @click="deleteAddress(item.id)">Удалить</v-btn>
        </template>
      </v-data-table>
  
      <!-- Модальное окно редактирования -->
      <v-dialog v-model="editDialog" max-width="500px">
        <v-card>
          <v-card-title>Редактировать адрес</v-card-title>
          <v-card-text>
            <!-- Дата (обрезается при сохранении) -->
            <v-text-field v-model="editedAddress.date" label="Дата" />
            <!-- Адрес с поиском -->
            <v-text-field
              v-model="editedAddress.address"
              label="Адрес"
              append-icon="mdi-magnify"
              @click:append="searchAddress"
            />
            <!-- Координаты -->
            <div v-if="foundLat && foundLon">
              <p>Координаты: {{ foundLat }}, {{ foundLon }}</p>
            </div>
            <!-- Количество -->
            <v-text-field
              v-model.number="editedAddress.count"
              label="Кол-во повторений"
              type="number"
              disabled
            />
          </v-card-text>
          <v-card-actions>
            <v-btn color="green" @click="updateAddress">Сохранить</v-btn>
            <v-btn color="grey" @click="editDialog = false">Отмена</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    name: 'ProblemAddresses',
    data() {
      return {
        addresses: [],
        headers: [
          { text: 'Дата', value: 'date' },
          { text: 'Адрес', value: 'address' },
          { text: 'Кол-во', value: 'count' },
          { text: 'Действия', value: 'actions', sortable: false },
        ],
        editDialog: false,
        editedAddress: {},
        foundLat: null,
        foundLon: null,
      };
    },
    mounted() {
      this.loadAddresses();
    },
    methods: {
      async loadAddresses() {
        try {
          const res = await axios.get('https://geonode.qpark.io/api/problem-addresses');
          this.addresses = res.data.map(addr => ({
            ...addr,
            date: addr.date.split('T')[0] // ✅ Исправлено отображение даты
          }));
        } catch (err) {
          console.error('Ошибка загрузки адресов:', err);
        }
      },
  
      openEdit(item) {
        this.editedAddress = { ...item };
        this.foundLat = null;
        this.foundLon = null;
        this.editDialog = true;
      },
  
      async searchAddress() {
        if (!this.editedAddress.address) return;
        try {
          const geoRes = await axios.get('https://geonode.qpark.io/api/search-address', {
            params: { q: this.editedAddress.address, format: 'json' }
          });
          if (geoRes.data.length) {
            const { lat, lon } = geoRes.data[0];
            this.foundLat = lat;
            this.foundLon = lon;
          } else {
            alert('Адрес не найден');
          }
        } catch (err) {
          console.error('Ошибка геокодирования:', err);
          alert('Ошибка геокодирования адреса');
        }
      },
  
      async updateAddress() {
        try {
          const payload = {
            date: this.editedAddress.date, // Дата уже обрезана при загрузке
            address: this.editedAddress.address
          };
          await axios.put(`https://geonode.qpark.io/api/problem-addresses/${this.editedAddress.id}`, payload);
          this.editDialog = false;
          this.loadAddresses();
        } catch (err) {
          console.error('Ошибка исправления адреса:', err);
          alert('Ошибка исправления адреса');
        }
      },
  
      async deleteAddress(id) {
        try {
          await axios.delete(`https://geonode.qpark.io/api/problem-addresses/${id}`);
          this.loadAddresses();
        } catch (err) {
          console.error('Ошибка удаления адреса:', err);
          alert('Ошибка удаления адреса');
        }
      },
    },
  };
  </script>
  